import {
  ArrowUUpLeftIcon,
  CalendarCheckIcon,
  ChartLineUpIcon,
  CheckCircleIcon,
  MoneyIcon,
  PercentIcon,
  ReceiptIcon,
  TagIcon,
  XCircleIcon,
} from '@phosphor-icons/react'
import { TFunction } from 'i18next'

import { ReservationAnalytics } from '@/api/reservations/get-reservation-analytics'
import { IconProps } from '@/components/ui/icon'
import { formatNumber } from '@/utils/number'

interface AnalyticsMetric {
  icon: IconProps['icon']
  iconSize?: string
  label: string
  getValue: (analytics: ReservationAnalytics) => string
}

const asCount = (value: number | undefined) => formatNumber(Number(value) || 0)
const asCurrency = (value: number | undefined) => `$${formatNumber(Number(value) || 0)}`

export const getReservationsAnalyticsMetrics = (
  t: TFunction<['reservations']>,
): AnalyticsMetric[] => [
  {
    getValue: (analytics) => asCount(analytics.totalReservations),
    icon: CalendarCheckIcon,
    label: t('reservations:analytics.metrics.totalReservations'),
  },
  {
    getValue: (analytics) => asCount(analytics.paidReservationsGrossTotal),
    icon: ReceiptIcon,
    label: t('reservations:analytics.metrics.paidReservationsGross'),
  },
  {
    getValue: (analytics) => asCount(analytics.discountedTotal),
    icon: PercentIcon,
    label: t('reservations:analytics.metrics.discountedTotal'),
  },
  {
    getValue: (analytics) => asCount(analytics.cancelledTotal),
    icon: XCircleIcon,
    label: t('reservations:analytics.metrics.canceledTotal'),
  },
  {
    getValue: (analytics) => asCount(analytics.paidReservationsNetTotal),
    icon: CheckCircleIcon,
    label: t('reservations:analytics.metrics.paidReservationsNet'),
  },
  {
    getValue: (analytics) => asCurrency(analytics.grossRevenue),
    icon: MoneyIcon,
    label: t('reservations:analytics.metrics.grossRevenue'),
  },
  {
    getValue: (analytics) => asCurrency(analytics.discountsPromotions),
    icon: TagIcon,
    label: t('reservations:analytics.metrics.discountsPromotions'),
  },
  {
    getValue: (analytics) => asCurrency(analytics.cancellationsRefunds),
    icon: ArrowUUpLeftIcon,
    label: t('reservations:analytics.metrics.cancellationsRefunds'),
  },
  {
    getValue: (analytics) => asCount(analytics.refundedTotal),
    icon: ArrowUUpLeftIcon,
    label: t('reservations:analytics.metrics.refundedTotal'),
  },
  {
    getValue: (analytics) => asCurrency(analytics.netRevenue),
    icon: ChartLineUpIcon,
    label: t('reservations:analytics.metrics.netRevenue'),
  },
]
